import { TrackingProvider } from '@meilleurtaux/form-factory-ds'
import { lazy, Suspense, useCallback, useState } from 'react'
import { Route, Routes, useSearchParams } from 'react-router'
import type { AppConfig, WidgetConfig } from 'type/app'
import Redirect from 'components/Redirect'
import Form from 'page/Form'
import { getAllCategoriesWithConsent } from 'utils/consent'
import { getUtmsFromQueryParams } from 'utils/utm'
const Reload = lazy(() => import('page/Reload'))

type AppProps =
  | {
      isWidget: true
      config: WidgetConfig
    }
  | {
      isWidget?: false
      config?: AppConfig
    }

function App({ isWidget, config }: AppProps) {
  const [tunnelId, setTunnelId] = useState<string | undefined>(undefined)
  const [userSheetId, setUserSheetId] = useState<string | undefined>(undefined)
  const [insukind, setInsukind] = useState<string | undefined>(undefined)
  let queryParams: URLSearchParams

  const setTrackingInformation = useCallback(
    ({
      tunnelId,
      userSheetId,
      insukind,
    }: {
      tunnelId: string
      userSheetId: string
      insukind: string
    }) => {
      setTunnelId(tunnelId)
      setUserSheetId(userSheetId)
      setInsukind(insukind)
    },
    [],
  )

  try {
    const [params] = useSearchParams()
    queryParams = params
  } catch {
    // En cas d'erreur (mode widget), utiliser des paramètres vides
    queryParams = new URLSearchParams()
  }

  // Mode Widget: Rendu direct du composant Form
  if (isWidget) {
    return (
      <TrackingProvider
        apiUrl={import.meta.env.VITE_API_URL}
        currentUrl={globalThis.location.href}
        insukind={insukind}
        tunnelId={tunnelId}
        userSheetId={userSheetId}
        utms={getUtmsFromQueryParams(queryParams, config)}
        isWidget={true}
        widgetConsent={config.consent}
        tcPrivacyConsent={getAllCategoriesWithConsent()}
      >
        <Form config={config} setTrackingInformation={setTrackingInformation} />
      </TrackingProvider>
    )
  }

  return (
    <TrackingProvider
      apiUrl={import.meta.env.VITE_API_URL}
      currentUrl={globalThis.location.href}
      insukind={insukind}
      tunnelId={tunnelId}
      userSheetId={userSheetId}
      utms={getUtmsFromQueryParams(queryParams, config)}
      tcPrivacyConsent={getAllCategoriesWithConsent()}
    >
      <Suspense fallback={null}>
        <Routes>
          <Route path="/reload" element={<Reload config={config} />} />
          <Route
            path="/:insukind/:route"
            element={<Form config={config} setTrackingInformation={setTrackingInformation} />}
          />
          <Route
            path="/:clientId"
            element={<Form config={config} setTrackingInformation={setTrackingInformation} />}
          />
          <Route
            path="/sante/qpp/page0"
            element={
              <Form
                config={config}
                setTrackingInformation={setTrackingInformation}
                insukindAB="sante"
                routeAB="qpp"
              />
            }
          />
          <Route path="*" element={<Redirect />} />
        </Routes>
      </Suspense>
    </TrackingProvider>
  )
}

export default App
